import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';

import styles from './styles';

const NoResultScreen = ({ classes, children, title, subTitle, showCompanyIcon, iconName, customClasses }) => {
  return (
    <div className={classNames(classes.container, customClasses?.container)}>
      <ADGMImage
        className={classNames(customClasses?.icon)}
        name={iconName || (showCompanyIcon ? 'add-company-entity.svg' : 'add-entity.svg')}
        alt='add-entity-icon'
      />
      <Typography className={classNames(classes.title, customClasses?.title)}>{keyEmptyCheck(title)}</Typography>
      {subTitle && (
        <Typography className={classNames(classes.subTitle, classes?.subTitle)}>{keyEmptyCheck(subTitle)}</Typography>
      )}
      {children}
    </div>
  );
};

NoResultScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  iconName: PropTypes.string,
  showCompanyIcon: PropTypes.bool,
  customClasses: PropTypes.object,
};

NoResultScreen.defaultProps = {
  subTitle: '',
  showCompanyIcon: false,
  customClasses: {},
  iconName: '',
};

export default withStyles(styles)(NoResultScreen);
